import React from 'react';
import { useLocale } from 'locale';
import { ShowAt } from 'consts/breakpoints';
import { InsightType } from 'utils/entities';
import WidgetWrapper from 'components/widget/common/widget-wrapper';
import { BuildingPermitItem } from 'components/insight-summary-renderer/BuildingPermitSummary/types';
import BuildingPermitTable from 'components/insight-summary-renderer/BuildingPermitSummary/BuildingPermitTable';
import { Title } from 'components/insight-summary-renderer/BuildingPermitSummary/styled';
import { InsightSection } from 'store/state/insightsContext';
import { Content } from './styled';


interface BuildingPermitWidgetProps {
  address: string;
  buildingPermitRequests: BuildingPermitItem[];
}

export const BuildingPermitWidget: React.FC<BuildingPermitWidgetProps> = props => {
  const { address, buildingPermitRequests } = props;
  const { t } = useLocale();

  if (!buildingPermitRequests.length) return null;

  return (
    <WidgetWrapper
      title={t('widgetTitle.buildingPermit')}
      targetId={InsightSection.BuildingPermit}
      styleType={InsightType.BuildingPermit}
    >
      <Content>
        <Title>{t('widget.buildingPermit.summary', { address: address || null })}</Title>
        <ShowAt at={1}>
          {matches => (
            <BuildingPermitTable
              isMobile={matches}
              data={buildingPermitRequests}
              visibleRowsDesktop={8}
              visibleRowsMobile={5}
              paginationType="pages"
            />
          )}
        </ShowAt>
      </Content>
    </WidgetWrapper>
  );
};
